/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Departments {
    angular.module("meevo.plugins.departments", []);
}